<script setup lang="ts">
import {HomeInterviewInstanceItem} from "@/home/interfaces";
import HomeLiveItem from "@/home/components/HomeLiveItem.vue";
import Icon from "@/core/components/icon/Icon.vue";
import {useRouter} from "vue-router";

const router = useRouter();
defineProps<{
    item: HomeInterviewInstanceItem['data']
}>();

/**
 * Redirect to the interview instance view.
 */
const goToInstance = (instance: HomeInterviewInstanceItem['data']) => {
    router.push({
        name: 'interview-instances',
        query: {
            customerId: instance.consumer?.customer_id,
            interviewId: instance.interview.id.toString(),
            consumerKey: instance.consumer_key,
            interviewInstanceId: instance.id.toString(),
            interviewName: instance.interview.name,
            backingId: instance.backing_id?.toString()
        }
    });
};
</script>

<template>
  <HomeLiveItem
    :at="item.started_at"
    @click="goToInstance(item)"
  >
    <template #image>
      <Icon name="mdi-chat" :size="50" color="primary" />
    </template>
    <p class="font-semibold">
      {{ item.consumer?.information?.name ?? "Anonyme" }}
    </p>
    <p>Compte rendu d'entretien à finaliser <span v-if="item.interview?.name">: {{ item.interview.name }}</span></p>
  </HomeLiveItem>
</template>
